import React, { memo, useState, useRef } from "react";
import { ReactComponent as ArrowIcon } from "../../../../../assets/svg/chevron.svg";
import { ReactComponent as FacebookIcon } from "../../../../../assets/svg/facebook-icon.svg";
import { ReactComponent as GMBIcon } from "../../../../../assets/svg/GMB.svg";
import { ReactComponent as TwitterIcon } from "../../../../../assets/svg/twitter-logo.svg";
import { ReactComponent as InstagramIcon } from "../../../../../assets/svg/instagram.svg";
import { ReactComponent as LinkedinIcon } from "../../../../../assets/svg/linkedin.svg";
import { ReactComponent as PlayStoreIcon } from "../../../../../assets/svg/play-store.svg";
import { ReactComponent as YoutubeIcon } from "../../../../../assets/svg/youtube-icon.svg";
import { ReactComponent as TelegramIcon } from "../../../../../assets/svg/telegram.svg";
import ChartOptionsSidebar from "./ChartOptionsSidebar";
import { Scrollbars } from "react-custom-scrollbars";
// import PlatformIcon from "../../../SMR/Icons/PlatformIcon";
import AppStoreIcon from "../../../../../assets/appstore.png";
// import { ReactComponent as AppStoreIcon } from "../../../../../assets/svg/app-store.svg";

const ChartIndexSelector = memo(
    ({
        options,
        onIndexChange,
        currentIndex,
        selectorType,
        currentName,
        widgetContainerRef,
        isFbPage,
        isTwitter,
        isInstagram,
        currentPlaform,
        limit,
        ...props
    }) => {
        // console.log("firstss", options, currentPlaform, selectorType, currentName);
        const [showMoreOptions, updateShowMoreOptions] = useState(false);
        const [showMoreOptionsLoc, updateShowMoreOptionsLoc] = useState(null);
        const arrowRef = useRef();

        const truncate = (str, maxValue = 30) => {
            const max = limit ? limit : maxValue;
            const ellipsis = str.length > max ? "..." : "";
            return str.slice(0, max) + ellipsis;
        };

        const changeShowMoreOptions = (e) => {
            let parent = widgetContainerRef.current.getBoundingClientRect();
            if (e && !showMoreOptions) {
                updateShowMoreOptions(true);
                updateShowMoreOptionsLoc({ x: e.clientX - parent.left - 75, y: e.clientY - parent.top - 35 });
            } else {
                updateShowMoreOptions(false);
                updateShowMoreOptionsLoc(null);
            }
        };

        const getOptions = () => {
            return options.map((x) => {
                return (
                    <div
                        key={x.value + x.label}
                        title={x.label}
                        className={`option ${currentIndex === x.value ? "active" : ""}`}
                        onClick={() => onIndexChange(x.value)}>
                        <p>{truncate(x.label)}</p>
                        {x?.peakPlatform == "facebook" ? (
                            <FacebookIcon />
                        ) : x?.peakPlatform == "instagram" ? (
                            <InstagramIcon />
                        ) : x?.peakPlatform == "twitter" ? (
                            <TwitterIcon />
                        ) : x?.peakPlatform == "gmb" ? (
                            <GMBIcon />
                        ) : x?.peakPlatform == "playstore" ? (
                            <PlayStoreIcon />
                        ) : x?.peakPlatform == "linkedin" ? (
                            <LinkedinIcon />
                        ) : x?.peakPlatform == "telegram" ? (
                            <TelegramIcon />
                        ) : x?.peakPlatform == "youtube" ? (
                            <YoutubeIcon />
                        ) : x?.peakPlatform == "appstore" ? (
                            <img src={AppStoreIcon} className="platform__icon" />
                        ) : (
                            ""
                        )}
                    </div>
                );
            });
        };

        return (
            <>
                {isFbPage || isTwitter || isInstagram ? (
                    <div className="dashboard-chart-item-name-span skiptranslate" onClick={(e) => changeShowMoreOptions(e)}>
                        {currentName}
                    </div>
                ) : (
                    <div className="dashboard-chart-item-name-span skiptranslate" onClick={(e) => changeShowMoreOptions(e)}>
                        {selectorType + " : " + currentName}
                        {/* {<PlatformIcon platform={currentPlaform} />} */}

                        {currentPlaform == "facebook" ? (
                            <FacebookIcon />
                        ) : currentPlaform == "instagram" ? (
                            <InstagramIcon />
                        ) : currentPlaform == "twitter" ? (
                            <TwitterIcon />
                        ) : currentPlaform == "gmb" ? (
                            <GMBIcon />
                        ) : currentPlaform === "playstore" ? (
                            <PlayStoreIcon />
                        ) : currentPlaform === "linkedin" ? (
                            <LinkedinIcon />
                        ) : currentPlaform == "telegram" ? (
                            <TelegramIcon />
                        ) : currentPlaform === "youtube" ? (
                            <YoutubeIcon />
                        ) : currentPlaform === "appstore" ? (
                            <img src={AppStoreIcon} className="platform__icon" />
                        ) : (
                            ""
                        )}
                    </div>
                )}

                <span data-html2canvas-ignore="true" className="chart-index-dropdown-arrow" ref={arrowRef} onClick={(e) => changeShowMoreOptions(e)}>
                    <ArrowIcon />
                </span>
                {showMoreOptionsLoc && (
                    <ChartOptionsSidebar showMoreOptionsLoc={showMoreOptionsLoc} changeShowMoreOptions={changeShowMoreOptions}>
                        <div className="chart-index-dropdown" style={{ height: options.length > 5 ? "120px" : "max-content" }}>
                            {options.length > 5 ? <Scrollbars>{getOptions()}</Scrollbars> : getOptions()}
                        </div>
                    </ChartOptionsSidebar>
                )}
            </>
        );
    },
);

export default ChartIndexSelector;
